import apiConfig from "constants/apiConfig"
import { Address, Coordinates, SavedAddress } from "../../types/address"
import axiosClient from "../../utils/axiosClient"

export const getReverseGeocode = async (hubId: string, coords: Coordinates) => {
    const response = await axiosClient.get(`/h/${hubId}/address/geocode?latlng=${coords.latitude},${coords.longitude}`)
    return response.data.results
}

export const fetchPlaces = async (hubId: string, searchQuery: string, coords: Coordinates) => {
    const response = await axiosClient.post(apiConfig.FETCH_MAP_PLACES.url, {
        input: searchQuery,
        ...(coords && {
            lat: coords.latitude,
            lng: coords.longitude
        })
    })

    return response.data.suggestions;
}

export const fetchPlace = async (hubId: string, placeId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_PLACE.url.replace('<hubId>', hubId).replace('<placeId>', placeId))

    return response.data;
}

export const storeAddress = async (hubId: string, influencerId: string, address: Address) => {
    const response = await axiosClient.post(apiConfig.STORE_ADDRESS.url.replace('<hubId>', hubId).replace('<influencerId>', influencerId), address);
    return response.data;
}

export const storeHubAddress = async (hubId: string, address: Address) => {
    const response = await axiosClient.post(apiConfig.STORE_HUB_ADDRESS.url.replace('<hubId>', hubId), address);
    return response.data;
}

export const fetchAdresses = async (hubId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_ADDRESSES.url.replace('<hubId>', hubId));
    return response.data.items as SavedAddress[];
}

export const fetchInfluencerAddresses = async (hubId: string, influencerId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_INFLUENCER_ADDRESSES.url.replace('<hubId>', hubId).replace('<influencerId>', influencerId));
    return response.data.items as SavedAddress[];
}

export const fetchAddress = async (hubId: string, addressId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_ADDRESS.url.replace('<hubId>', hubId).replace('<addressId>', addressId));
    return response.data?.address as SavedAddress;
}

export const fetchDecodedAddress = async (hubId: string, place_id: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_PLACE_LOCAL.url.replace('<hubId>', hubId), {params: {place_id}});
    return response.data.address as Address;
}